import React from 'react'
import ReactDOM from 'react-dom'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { SnackbarProvider } from 'notistack'
import { ApolloProvider } from 'react-apollo'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import 'antd/dist/antd.min.css'
import configureStore from './store'
import App from './pages/App'
import registerServiceWorker from './registerServiceWorker'
import client from './graphql'
import { ConfigProvider, message } from 'antd'
import 'moment/locale/th'
import moment from 'moment-timezone'

moment().locale('th')
moment().tz('Asia/Bangkok')

message.config({
  top: 100
})

require('dotenv').config()

const { store, persistor } = configureStore()

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#6ebf4b'
    }
  },
  typography: {
    useNextVariants: true
  },
  overrides: {
    MuiAppBar: {
      root: {
        boxShadow: '0px 4px 8px rgba(38, 50, 56, 0.08)'
      },
      colorDefault: {
        color: 'white'
      },
      colorPrimary: {
        color: 'white'
      }
    },
    MuiPaper: {
      root: {
        backgroundColor: 'white'
      }
    },
    MuiAvatar: {
      colorDefault: {
        backgroundColor: '#a8bf4b'
      }
    },
    MuiChip: {
      clickableColorPrimary: {
        color: 'white'
      },
      deletableColorPrimary: {
        color: 'white'
      },
      deleteIconColorPrimary: {
        color: 'white'
      }
    },
    MuiListItemIcon: {
      root: {
        marginRight: '0px',
        color: '#77a662'
      }
    },
    MuiTypography: {
      root: {
        color: '#77a662'
      },
      body1: {
        color: '#77a662'
      }
    },
    MuiButton: {
      containedPrimary: {
        color: 'white'
      },
      label: {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    MuiFab: {
      primary: {
        color: 'white'
      }
    },
    MuiCard: {
      root: {
        backgroundColor: 'white',
        maxWidth: '600px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    }
  }
})

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <ApolloProvider client={client}>
      <SnackbarProvider maxSnack={3}>
        <CssBaseline />
        <ConfigProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </Provider>
        </ConfigProvider>
      </SnackbarProvider>
    </ApolloProvider>
  </MuiThemeProvider>,
  document.getElementById('root')
)

registerServiceWorker()

if (module.hot) module.hot.accept()



// WEBPACK FOOTER //
// ./src/index.js